import React from 'react'
import Sidebar from '../../Navigation/Sidebar/Sidebar'
import "./style.css"

export const LandingPage = () => {
  return (
 <div className='welcome-container' >
    <div>
        <Sidebar/>
    </div>
    <div className='welcomelayout' style={{margin:"auto"}} >
      <div className='greatingMsg' >
      
      </div>
      <h3>Welcome To Daalchini </h3>
    </div>
 </div>
  )
}
